type ShortcutEntry = {
  keys: string;
  description: string;
};

const SHORTCUT_SECTIONS: Array<{ title: string; shortcuts: ShortcutEntry[] }> = [
  {
    title: 'General',
    shortcuts: [
      { keys: '⌘ K', description: 'Open command palette' },
      { keys: '?', description: 'Show keyboard shortcuts' },
      { keys: '⌘ B', description: 'Toggle sidebar' },
      { keys: '/', description: 'Focus prompt input' },
      { keys: 'F', description: 'Toggle fullscreen' },
      { keys: '1 / 2 / 3', description: 'Switch tab (Chat / Code / History)' },
      { keys: 'E', description: 'Export SVG' },
      { keys: 'I', description: 'Toggle properties panel' },
    ],
  },
  {
    title: 'Editing',
    shortcuts: [
      { keys: '⌘ ↵', description: 'Send prompt' },
      { keys: '⌘ S', description: 'Render code changes' },
      { keys: '⌘ Z', description: 'Undo' },
      { keys: '⌘ ⇧ Z', description: 'Redo' },
    ],
  },
  {
    title: 'Canvas',
    shortcuts: [
      { keys: 'Scroll', description: 'Zoom in/out' },
      { keys: 'Drag', description: 'Pan canvas' },
      { keys: 'Space + Drag', description: 'Pan mode (Figma-style)' },
    ],
  },
];

type ShortcutsHelpProps = {
  open: boolean;
  onClose: () => void;
};

export function ShortcutsHelp({ open, onClose }: ShortcutsHelpProps) {
  if (!open) return null;

  return (
    <div className="ds-modal-overlay" onClick={onClose}>
      <div className="ds-modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="ds-modal__head">
          <h2 className="ds-modal__title">Keyboard Shortcuts</h2>
          <button type="button" className="ds-icon-btn" onClick={onClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--ds-space-4)' }}>
          {SHORTCUT_SECTIONS.map((section) => (
            <div key={section.title}>
              <div className="ds-shortcuts__section-title">{section.title}</div>
              <div className="ds-shortcuts__list">
                {section.shortcuts.map((sc) => (
                  <div key={sc.keys} className="ds-shortcuts__row">
                    <span className="ds-shortcuts__desc">{sc.description}</span>
                    <kbd className="ds-shortcuts__kbd">{sc.keys}</kbd>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
